import { render, staticRenderFns } from "./CreateDataScopeForm.vue?vue&type=template&id=bea7b498&scoped=true"
import script from "./CreateDataScopeForm.vue?vue&type=script&lang=js"
export * from "./CreateDataScopeForm.vue?vue&type=script&lang=js"
import style0 from "./CreateDataScopeForm.vue?vue&type=style&index=0&id=bea7b498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea7b498",
  null
  
)

export default component.exports